module.exports = __webpack_public_path__ + "img/banner_responsive.aefb81db.jpg";